export default "__VITE_ASSET__CRkI_avC__"